import { Box, Flex, Input, Text } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import CTable from "../../../components/Table/table";


import Select from "react-select";
import { paymentReportRequest } from "../../../modules/admin-modules/reports/Actions";
import { getAllLecturesRequest } from "../../../modules/admin-modules/lectures/Actions";
import { getPaymentSubjectRequest } from "../../../modules/admin-modules/videos/Actions";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import { CSVLink } from "react-csv";

const PaymentReport = () => {
  const dispatch = useDispatch();
  const [date, setDate] = useState(dayjs().format("YYYY-MM-DD"));
  const [lectureId, setLectureId] = useState("");
  const [paymentSubjectId, setPaymentSubjectId] = useState("");

  useEffect(() => {
    dispatch(getAllLecturesRequest());
    dispatch(getPaymentSubjectRequest());
  }, []);

  const formatDate = (isoString) => {
    if (!isoString) return "";
    const d = dayjs(isoString);
    return d.isValid() ? d.format("DD/MM/YYYY HH:mm") : isoString;
  };

  useEffect(() => {
    if (!date || !lectureId) return;
    const payload = { date, lecture_id: lectureId };
    if (paymentSubjectId) payload.payment_subject_id = paymentSubjectId;
    dispatch(paymentReportRequest(payload));
  }, [date, lectureId, paymentSubjectId]);

  const lectures = useSelector((state) => state.lectures.lectures);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const paymentReport = useSelector((state) => state.reports.paymentReport);
  const isLoading = useSelector((state) => state.reports.isLoading);

  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);

  const lectureOptions = lectures?.map((data) => ({
    value: data.id,
    label: data.title,
  }));

  const paymentSubjectOptions = paymentSubjects?.map((data) => ({
    value: data.id,
    label: data.name,
  }));

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const headers = [
    { label: "name", key: "name" },
    { label: "phone", key: "phone" },
    { label: "user_name", key: "user_name" },
    { label: "paid_amount", key: "paid_amount" },
    { label: "remaining_amount", key: "remaining_amount" },
    { label: "comment", key: "comment" },
    { label: "payment_subject_name", key: "payment_subject_name" },
    { label: "lecture_name", key: "lecture_name" },
    { label: "scan_by", key: "scan_by" },
    { label: "created_at", key: "created_at" },
  ];

  const paymentList = Array.isArray(paymentReport) ? paymentReport : [];
  const Data = paymentList.map((data, index) => ({
    ...data,
    index: `#${index + 1}`,
    id: data?.id,
    name: data?.name,
    phone: data?.phone,
    user_name: data?.user_name,
    paid_amount: data?.paid_amount,
    remaining_amount: data?.remaining_amount,
    comment: data?.comment,
    payment_subject_name: data?.payment_subject?.name ?? data?.payment_subject_name ?? "",
    lecture_name: data?.lecture_id?.name ?? data?.lecture_id?.title ?? data?.lecture_name ?? "",
    scan_by: data?.scan_by ?? "",
    created_at: formatDate(data?.created_at),
  }));

  const columns = [
    { Header: "#", accessor: "index" },
    { Header: "الاسم", accessor: "name" },
    { Header: "الهاتف", accessor: "phone" },
    { Header: "اسم المستخدم", accessor: "user_name" },
    { Header: "المبلغ المدفوع", accessor: "paid_amount" },
    { Header: "المبلغ المتبقي", accessor: "remaining_amount" },
    { Header: "تعليق", accessor: "comment" },
    { Header: "مادة الدفع", accessor: "payment_subject_name" },
    { Header: "السنتر", accessor: "lecture_name" },
    { Header: "مسح بواسطة", accessor: "scan_by" },
    { Header: "تاريخ الإنشاء", accessor: "created_at" },
  ];

  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
          flexWrap="wrap"
          gap="4"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير الدفع
          </Text>
          <Flex
            w={{ base: "100%", md: "auto" }}
            flexDirection={{ base: "column", md: "row" }}
            alignItems={{ base: "stretch", md: "center" }}
            gap="3"
          >
            <Box w={{ base: "100%", md: "200px" }}>
              <Input
                type="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                bg="gray.100"
                borderRadius="16px"
                border="1px solid"
                borderColor="gray.200"
              />
            </Box>
            <Box w={{ base: "100%", md: "200px" }}>
              <Select
                options={lectureOptions}
                isMulti={false}
                onChange={(data) => setLectureId(data?.value ?? "")}
                styles={colourStyles}
                placeholder="اختر السنتر"
              />
            </Box>
            <Box w={{ base: "100%", md: "200px" }}>
              <Select
                options={paymentSubjectOptions}
                isMulti={false}
                onChange={(data) => setPaymentSubjectId(data?.value ?? "")}
                styles={colourStyles}
                placeholder="اختر مادة الدفع (اختياري)"
              />
            </Box>
            <Box
              border="1px solid gray"
              borderRadius="8px"
              padding="10px"
              alignSelf="center"
            >
              <CSVLink
                headers={headers}
                data={Data?.length ? Data : []}
                filename={"payment-report.csv"}
                className="btn btn-primary"
                target="_blank"
              >
                Download
              </CSVLink>
            </Box>
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={() => {}}
          Columns={columns}
          Data={Data}
          path="openModel"
          Actions
          Title=""
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={isLoading}
          perPage={size}
          totalPage={Math.ceil((Data?.length || 0) / size) || 1}
        />
      </div>
    </Layout>
  );
};

export default PaymentReport;
